import {ENDPOINTS} from '~/constants';
import {DeleteParams, FetchParams, PostParams, PutParams} from 'redux-thunk-kit';
import {thunk} from '~/utils/thunk';
import {AdminEntity, NormalizedAdmin} from '~/types/models/admin';
import {adminSchema} from '~/redux/admins/entity-config';

export interface FetchUserInfoParams extends FetchParams {
  [key: string]: any;
}

export interface FetchAdminsParams extends FetchParams {
  [key: string]: any;
}

export interface AddAdminParams extends PostParams {
  [key: string]: any;
  data: Partial<AdminEntity>;
}

export interface UpdateAdminParams extends PutParams {
  [key: string]: any;
  data: Partial<AdminEntity>;
  id: number;
}

const query = thunk.query<AdminEntity, NormalizedAdmin>('admin', adminSchema);
// export const fetchAdmins = query.fetch<FetchAdminsParams>(ENDPOINTS.ADMINS);
// export const addAdmin = query.post<AddAdminParams>(ENDPOINTS.ADMINS);
// export const updateAdmin = query.put<UpdateAdminParams>(`${ENDPOINTS.ADMINS}/:id`);
// export const deleteAdmin = query.delete<DeleteParams>(`${ENDPOINTS.ADMINS}/:id`);

// export const fetchCurrentAdminInfo = query.fetchOne<FetchUserInfoParams>(ENDPOINTS.CURRENT_USER, 'admin/me/detail', {
//   includeApiResponseData: true,
// });
export const fetchCurrentUserInfo = query.fetchOne<FetchUserInfoParams>(ENDPOINTS.CURRENT_USER, 'user/me/detail', {
  includeApiResponseData: true,
});
